export default __webpack_public_path__ + "static/Mask Group 16-03336ecfacfc93b7a5c0de1792cdb415.png";